var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToggleTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000140000830326188122060000013239372036337685676_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5.976c-4.7,0-8.524,3.824-8.524,8.524S9.8,23.023,14.5,23.023s8.523-3.823,8.523-8.523S19.2,5.976,14.5,5.976z  M6.976,14.5c0-4.012,3.159-7.291,7.119-7.503v15.006C10.135,21.791,6.976,18.512,6.976,14.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 29,
    height: 29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleTheme);
export default __webpack_public_path__ + "static/media/icon-toggle-theme.9c99c603af51ccda0f03fb1990d90e57.svg";
export { ForwardRef as ReactComponent };